// ============================================================================
// OBT F2-A — Kampanya ekranı (liste ↔ oluşturma)
// ============================================================================
// Yerel görünüm state'i ile liste ve oluşturucu arasında geçiş yapar. Yeni
// global router KURULMAZ; mevcut activeTab mimarisi korunur (Sidebar/App.js'e
// dokunulmaz). Dashboard'lar bu bileşeni gömerek "Kampanyalar" kartını işlevsel
// hale getirir.
//
// Yalnız yayıncı roller (mudur/mudur_yardimcisi/bolge_muhendisi) "Yeni Kampanya"
// görür. Backend, oluşturma ucunda rol kapısı uygulamasa da yayın anında
// PUBLISHER_ROLES + zincir kapsamını zorunlu kılar; bu istemci kontrolü UX'tir.
// ============================================================================

import { useState } from 'react';
import { useAuthorization } from '@/auth/AuthorizationContext';
import CampaignListView from './CampaignListView';
import CampaignBuilder from './CampaignBuilder';
import { OBT_PUBLISHER_ROLES } from './campaignEnums';

/**
 * @param {object} props
 * @param {boolean} props.enabled  Yetki kapısı kesinleşmeden veri çekilmez
 * @param {() => void} [props.onBack]  Panele geri dönüş (opsiyonel)
 */
export default function CampaignScreen({ enabled = true, onBack }) {
  const { personnelId, role, userRole } = useAuthorization();
  const effectiveRole = role || userRole || '';
  const canPublish = OBT_PUBLISHER_ROLES.includes(effectiveRole);

  const [mode, setMode] = useState('list'); // 'list' | 'builder'
  // Düzenlenen taslak (null → yeni kampanya). Her oturum tasarımcıyı
  // sıfırlamak için `key` olarak da kullanılır.
  const [editCampaignId, setEditCampaignId] = useState(null);
  const [builderKey, setBuilderKey] = useState(0);
  // "Geri çek ve düzenle" akışında önceki hedefler (BM/Formen) → TargetPicker
  // yeniden yayında bunları önceden seçili getirir. Normal taslak düzenlemede boş.
  const [initialTargetIds, setInitialTargetIds] = useState([]);

  const openBuilder = (campaignId, targetIds) => {
    setEditCampaignId(campaignId || null);
    setInitialTargetIds(Array.isArray(targetIds) ? targetIds : []);
    setBuilderKey((k) => k + 1);
    setMode('builder');
  };

  if (mode === 'builder') {
    return (
      <CampaignBuilder
        key={builderKey}
        personnelId={personnelId}
        campaignId={editCampaignId}
        initialTargetIds={initialTargetIds}
        onDone={() => setMode('list')}
      />
    );
  }

  return (
    <CampaignListView
      enabled={enabled}
      onNewCampaign={canPublish ? () => openBuilder(null) : null}
      onEditDraft={canPublish ? (id, targetIds) => openBuilder(id, targetIds) : null}
      canExtend={canPublish}
      onBack={onBack}
    />
  );
}
